export default __webpack_public_path__ + "static/media/banner2.a6d91e9f.jpg";